import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismComboSelectInput } from '@mylighthouse/prism-ember';
import { not } from 'ember-truth-helpers';

interface GeneralDropdownsDropdownExportSignature {
  Args: {
    export: unknown;
    exportChoices: unknown;
    isScheduleDisabled: unknown;
  };
  Element: HTMLElement;
}

export default class GeneralDropdownsDropdownExport extends Component<GeneralDropdownsDropdownExportSignature> {
  @service declare access: Services['access'];
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get options() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return, @typescript-eslint/unbound-method
    return this.args.exportChoices.map(this.mapExportChoiceToOption);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get value() {
    return {
      icon: 'export',
      label: this.intl.t('general.export'),
    };
  }

  // @TODO I don't think this logic belongs in this component, the responsibility should be moved to the parent components
  // @ts-expect-error: Incorrect type
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  label(exportChoice) {
    // Default to the label property
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    let { label = '' } = exportChoice;

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exportChoice.toTranslate) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (exportChoice.selection) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        label = this.intl.t(exportChoice.toTranslate, {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          count: exportChoice.selection,
        });
      } else {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        label = this.intl.t(exportChoice.toTranslate);
      }
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    label += exportChoice.title || '';

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return label;
  }

  // @TODO I don't think this logic belongs in this component, the responsibility should be moved to the parent components
  @action
  // @ts-expect-error: Incorrect type
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  mapExportChoiceToOption(exportChoice) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exportChoice.groupName) {
      return {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        groupName: exportChoice.groupName,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/unbound-method
        options: exportChoice.options.map(this.mapExportChoiceToOption),
      };
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const label = this.label(exportChoice);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const scheduleDisabled =
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      exportChoice.id === 'schedule_report' &&
      // @ts-expect-error: Incorrect type
      this.args.isScheduleDisabled.disabled;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (scheduleDisabled || exportChoice.showAsDisabled) {
      let message = this.intl.t('rates.export.nodata_message');

      if (scheduleDisabled) {
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        message = this.args.isScheduleDisabled.message;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      } else if (exportChoice.showAsDisabled) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        message = exportChoice.message;
      }

      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return {
        ...exportChoice,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        label,
        disabled: true,
        disabledMessage: message,
      };
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
      ...exportChoice,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      label,
    };
  }

  <template>
    <PrismComboSelectInput
      @disabled={{not this.access.hasReports}}
      {{! @glint-expect-error: Incorrect type }}
      @onChange={{@export}}
      @options={{this.options}}
      @unsafe_hasDropdownMaxHeight={{false}}
      @unsafe_renderInPlace={{true}}
      {{! @glint-expect-error: Incorrect type }}
      @value={{this.value}}
      ...attributes
    />
  </template>
}
